import { c as _c } from "react/compiler-runtime";
import { Searchbar } from "@components/header/searchbar";
import { FilterChipsBar } from "@components/common/faro-table/faro-table-filter/filter-chips-bar";
import { FilterToggleButton } from "@components/common/faro-table/faro-table-filter/filter-toggle-button";
import { Stack } from "@mui-wrapper";
import { Text } from "@flat-ui";
import { useState } from "react";
import { useMediaQueryList } from "@hooks/use-media-query";
import { LoadingWrapper } from "@context-providers/loading-state-context";
import { isAnyFilterAppliedIn } from "@hooks/table-filters/use-filter-query-params";
import { useSearchParams } from "react-router-dom";
import { EntitiesToolbarMobile } from "@components/common/toolbar/entities-toolbar-mobile";

/**
 * Height of flat-ui's search field. The sort and export sections take the same height and centre
 * their content, so every item shares the field's centre line. The row itself stays top-aligned,
 * so a validation message under the search field does not push the other items down.
 */
const TOOLBAR_ROW_HEIGHT = "2.25rem";
/** Toolbar to show on top of page that displays entities */
export function EntitiesToolbar(t0) {
  const $ = _c(66);
  const {
    sortActions,
    numberOfRows,
    totalNumberOfRows,
    exportComponent,
    toolbarEntityName,
    isLoading: t1,
    shouldShowRowsLabel: t2,
    shouldSkipValidation: t3,
    shouldStack: t4,
    shouldRemoveTopMargin: t5,
    filterChips,
    isAnyFilterApplied,
    mobileAction
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const shouldShowRowsLabel = t2 === undefined ? true : t2;
  const shouldSkipValidation = t3 === undefined ? false : t3;
  const shouldStack = t4 === undefined ? false : t4;
  const shouldRemoveTopMargin = t5 === undefined ? false : t5;
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const [searchParams] = useSearchParams();
  let t6;
  if ($[0] !== isAnyFilterApplied || $[1] !== searchParams) {
    t6 = () => isAnyFilterApplied ?? isAnyFilterAppliedIn(searchParams);
    $[0] = isAnyFilterApplied;
    $[1] = searchParams;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const [isFilterBarOpen, setIsFilterBarOpen] = useState(t6);
  const defaultTopMargin = isScreenSmOrSmaller ? "1rem" : "1.25rem";
  const topMargin = shouldRemoveTopMargin ? 0 : defaultTopMargin;
  const hasTotalRows = totalNumberOfRows !== undefined;
  const shouldRenderRowsLabel = shouldShowRowsLabel && (hasTotalRows || numberOfRows > 0);
  const entityLabel = (hasTotalRows ? totalNumberOfRows : numberOfRows) === 1 ? toolbarEntityName : `${toolbarEntityName}s`;
  let t7;
  if ($[3] !== entityLabel || $[4] !== hasTotalRows || $[5] !== numberOfRows || $[6] !== shouldRenderRowsLabel || $[7] !== totalNumberOfRows) {
    t7 = shouldRenderRowsLabel && <Text variant="bodyS" component="var">{hasTotalRows ? `${numberOfRows} of ${totalNumberOfRows} ${entityLabel}` : `${numberOfRows} ${entityLabel}`}</Text>;
    $[3] = entityLabel;
    $[4] = hasTotalRows;
    $[5] = numberOfRows;
    $[6] = shouldRenderRowsLabel;
    $[7] = totalNumberOfRows;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const rowsLabel = t7;
  let t8;
  if ($[9] !== isLoading || $[10] !== sortActions) {
    t8 = sortActions && <LoadingWrapper isLoading={isLoading}><Stack sx={{
        flex: 1,
        minHeight: TOOLBAR_ROW_HEIGHT,
        justifyContent: "center"
      }}>{sortActions}</Stack></LoadingWrapper>;
    $[9] = isLoading;
    $[10] = sortActions;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const sortActionsWrapper = t8;
  let t9;
  if ($[12] !== filterChips || $[13] !== isFilterBarOpen || $[14] !== sortActionsWrapper) {
    t9 = filterChips ? <Stack direction="row" sx={{
      alignItems: "center",
      gap: 1,
      minHeight: TOOLBAR_ROW_HEIGHT
    }}><FilterToggleButton isOpen={isFilterBarOpen} onToggle={() => setIsFilterBarOpen(!isFilterBarOpen)} />{sortActionsWrapper}</Stack> : sortActionsWrapper;
    $[12] = filterChips;
    $[13] = isFilterBarOpen;
    $[14] = sortActionsWrapper;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const sortAndFilterActions = t9;
  let t10;
  if ($[16] !== filterChips || $[17] !== isFilterBarOpen) {
    t10 = filterChips && isFilterBarOpen && <FilterChipsBar filterChips={filterChips} />;
    $[16] = filterChips;
    $[17] = isFilterBarOpen;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const filterChipsBar = t10;
  if (isScreenSmOrSmaller) {
    let t11;
    if ($[19] !== filterChips || $[20] !== isFilterBarOpen) {
      t11 = filterChips && <FilterToggleButton isIconOnly={true} isOpen={isFilterBarOpen} onToggle={() => setIsFilterBarOpen(!isFilterBarOpen)} />;
      $[19] = filterChips;
      $[20] = isFilterBarOpen;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    const t12 = (totalNumberOfRows ?? numberOfRows) > 0;
    let t13;
    if ($[22] !== exportComponent || $[23] !== filterChipsBar || $[24] !== mobileAction || $[25] !== rowsLabel || $[26] !== shouldSkipValidation || $[27] !== sortActionsWrapper || $[28] !== t11 || $[29] !== t12 || $[30] !== topMargin) {
      t13 = <EntitiesToolbarMobile topMargin={topMargin} mobileAction={mobileAction} filterButton={t11} sortActions={sortActionsWrapper} rowsLabel={rowsLabel} exportComponent={exportComponent} shouldSkipValidation={shouldSkipValidation} hasRows={t12}>{filterChipsBar}</EntitiesToolbarMobile>;
      $[22] = exportComponent;
      $[23] = filterChipsBar;
      $[24] = mobileAction;
      $[25] = rowsLabel;
      $[26] = shouldSkipValidation;
      $[27] = sortActionsWrapper;
      $[28] = t11;
      $[29] = t12;
      $[30] = topMargin;
      $[31] = t13;
    } else {
      t13 = $[31];
    }
    return t13;
  }
  let t11;
  if ($[32] !== topMargin) {
    t11 = {
      mt: topMargin,
      mb: "1.25rem",
      gap: 1
    };
    $[32] = topMargin;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  const t12 = shouldStack ? "column" : "row";
  const t13 = shouldStack ? "flex-start" : "space-between";
  const t14 = shouldStack ? "stretch" : "start";
  let t15;
  if ($[34] !== t12 || $[35] !== t13 || $[36] !== t14) {
    t15 = {
      flexDirection: t12,
      justifyContent: t13,
      alignItems: t14
    };
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  const t16 = shouldStack ? "column" : "row";
  const t17 = shouldStack ? "stretch" : "start";
  const t18 = shouldStack ? "0.75rem" : 0;
  let t19;
  if ($[38] !== t17 || $[39] !== t18) {
    t19 = {
      alignItems: t17,
      gap: t18
    };
    $[38] = t17;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== shouldSkipValidation || $[42] !== shouldStack) {
    t20 = <Searchbar shouldFullWidth={shouldStack} shouldSkipValidation={shouldSkipValidation} />;
    $[41] = shouldSkipValidation;
    $[42] = shouldStack;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== exportComponent || $[45] !== rowsLabel || $[46] !== shouldStack || $[47] !== sortAndFilterActions) {
    t21 = shouldStack ? <Stack direction="row" sx={{
      justifyContent: "space-between",
      alignItems: "center",
      gap: 2
    }}>{sortAndFilterActions}<Stack direction="row" sx={{
        alignItems: "center",
        gap: 2
      }}>{rowsLabel}{exportComponent}</Stack></Stack> : sortAndFilterActions;
    $[44] = exportComponent;
    $[45] = rowsLabel;
    $[46] = shouldStack;
    $[47] = sortAndFilterActions;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t16 || $[50] !== t19 || $[51] !== t20 || $[52] !== t21) {
    t22 = <Stack direction={t16} sx={t19}>{t20}{t21}</Stack>;
    $[49] = t16;
    $[50] = t19;
    $[51] = t20;
    $[52] = t21;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== exportComponent || $[55] !== rowsLabel || $[56] !== shouldStack) {
    t23 = !shouldStack && <Stack direction="row" sx={{
      alignItems: "center",
      minHeight: TOOLBAR_ROW_HEIGHT,
      gap: 2
    }}>{rowsLabel}{exportComponent}</Stack>;
    $[54] = exportComponent;
    $[55] = rowsLabel;
    $[56] = shouldStack;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== t15 || $[59] !== t22 || $[60] !== t23) {
    t24 = <Stack sx={t15}>{t22}{t23}</Stack>;
    $[58] = t15;
    $[59] = t22;
    $[60] = t23;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[62] !== filterChipsBar || $[63] !== t11 || $[64] !== t24) {
    t25 = <Stack sx={t11}>{t24}{filterChipsBar}</Stack>;
    $[62] = filterChipsBar;
    $[63] = t11;
    $[64] = t24;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  return t25;
}